import gql from "graphql-tag";

export default gql`
  query lessonActivities($filter: JSON!) {
    lessonActivities(filter: $filter) {
      _id
      name
      description
      materials
      instructions
      tags
    }
  }
`;
